import { get } from "lodash";

export const shouldShowMonthlySub = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodMonthly")) ||
      (Boolean(get(data, "covenants.guarantorListOfDocsMonthly")) && get(data, "covenants.guarantorListOfDocsMonthly").length > 0) ||
      Boolean(get(data, "covenants.guarantorDocsMonthlyReportingStart"));

export const shouldShowQuarterlySub = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodQuarterly")) ||
      (Boolean(get(data, "covenants.guarantorListOfDocsQuarterly")) && get(data, "covenants.guarantorListOfDocsQuarterly").length > 0) ||
      Boolean(get(data, "covenants.guarantorDocsQuarterlyReportingStart"));

export const shouldShowSemiAnnuallySub = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodSemiAnnually")) ||
      (Boolean(get(data, "covenants.guarantorListOfDocsSemiAnnually")) && get(data, "covenants.guarantorListOfDocsSemiAnnually").length > 0) ||
      Boolean(get(data, "covenants.guarantorDocsSemiAnnuallyReportingStart"));

export const shouldShowAnnuallySub = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodAnnually")) ||
      (Boolean(get(data, "covenants.guarantorListOfDocsAnnually")) && get(data, "covenants.guarantorListOfDocsAnnually").length > 0) ||
      Boolean(get(data, "covenants.guarantorDocsAnnuallyReportingStart"));

export const shouldShowGuarantorDeliveryPeriodMonthly = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodMonthly"));

export const shouldShowGuarantorDeliveryPeriodQuarterly = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodQuarterly"));

export const shouldShowGuarantorDeliveryPeriodSemiAnnually = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodSemiAnnually"));

export const shouldShowGuarantorDeliveryPeriodAnnually = data => Boolean(get(data, "covenants.guarantorDeliveryPeriodAnnually"));

export const shouldShowListOfDocsMonthly = data => {
  const docs = get(data, "covenants.guarantorListOfDocsMonthly");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsQuarterly = data => {
  const docs = get(data, "covenants.guarantorListOfDocsQuarterly");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsSemiAnnually = data => {
  const docs = get(data, "covenants.guarantorListOfDocsSemiAnnually");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsAnnually = data => {
  const docs = get(data, "covenants.guarantorListOfDocsAnnually");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowGuarantorDocsMonthly = data => Boolean(get(data, "covenants.guarantorDocsMonthlyReportingStart"));

export const shouldShowGuarantorDocsQuarterly = data => Boolean(get(data, "covenants.guarantorDocsQuarterlyReportingStart"));

export const shouldShowGuarantorDocsSemiAnnually = data => Boolean(get(data, "covenants.guarantorDocsSemiAnnuallyReportingStart"));

export const shouldShowGuarantorDocsAnnually = data => Boolean(get(data, "covenants.guarantorDocsAnnuallyReportingStart"));

export const shouldShowGuarantorOfficerCertificate = data => Boolean(get(data, "covenants.guarantorOfficerCertificate"));

export const shouldShowSignor = data => get(data, "covenants.guarantorOfficerCertificate");
